import React, {Component} from 'react';
import Checkbox from "../../../checkbox";
import {Scrollbars} from "react-custom-scrollbars";

/**
 * Класс для отображения информации о сеансе или рекламы
 */
class Info extends Component {
  /**
   * Конструктор класса
   * @param props
   */
  constructor(props) {
    super(props);

    this.state = {
      info: this.getInfo(),
      agree: false,
    };
  }

  getInfo = () => {
    const info = this.props.sessionInfo[this.props.session.id];
    if (info === undefined || !info) {
      return null;
    }

    return info;
  };

  /**
   * Метод дял определения нужено ли показывать чекбокс соглачия
   * @returns {boolean}
   */
  needAgree = () => {
    return this.state.info.agree === true;
  };

  /**
   * Устанавливаем активирован ли чекбокс согласия или нет
   */
  changeAgree = (val, name) => {
    if (val > 0) {
      this.setState({
        agree: true
      });
    } else {
      this.setState({
        agree: false
      });
    }
  };

  /**
   * Если галка согласия условий стоит то переключаемся на след экран для вводат тел
   * @param {Boolean} flag Если true то принудительно перейти на следующий шаг
   */
  toCheckout = (flag = false) => {
    if (!this.needAgree()) {
      flag = true;
    }

    if (this.state.agree || flag) {
      this.props.onCheckout();
    }
  };

  // Получаем универсальный iframe URL из любой ссылки
  getIframeUrl = (link) => {
    if (!link) return null;

    // Если ссылка уже содержит /embed/ - используем как есть
    if (link.includes('/embed/') || link.includes('/play/embed/')) {
      return link;
    }

    // YouTube - преобразуем различные форматы ссылок в embed
    const youtubeRegex = /^https?\:\/\/(?:www\.youtube(?:\-nocookie)?\.com\/|m\.youtube\.com\/|youtube\.com\/)?(?:ytscreeningroom\?vi?=|youtu\.be\/|vi?\/|user\/.+\/u\/\w{1,2}\/|embed\/|watch\?(?:.*\&)?vi?=|\&vi?=|\?(?:.*\&)?vi?=)([^#\&\?\n\/<>"']*)/i;
    const youtubeMatch = link.match(youtubeRegex);
    if (youtubeMatch && youtubeMatch[1] && youtubeMatch[1].length === 11) {
      return `//www.youtube.com/embed/${youtubeMatch[1]}`;
    }

    // Rutube - преобразуем в embed формат
    const rutubeRegex = /(?:https?:\/\/)?(?:www\.)?rutube\.ru\/(?:video|play\/embed)\/([a-zA-Z0-9]+)/i;
    const rutubeMatch = link.match(rutubeRegex);
    if (rutubeMatch && rutubeMatch[1]) {
      return `//rutube.ru/play/embed/${rutubeMatch[1]}`;
    }

    // Если ссылка уже выглядит как готовый iframe URL (начинается с http/https) - используем как есть
    if (link.match(/^https?:\/\//)) {
      return link;
    }

    // В остальных случаях возвращаем ссылку как есть (предполагая, что это уже готовый embed URL)
    return link;
  };

  /**
   * Рендерим html
   * @returns {JSX.Element}
   */
  render() {
    const {onBackClick} = this.props;
    const {agree, info} = this.state;

    const btnClasses = ['btn', 'btn--accent'];
    if (!agree && this.needAgree()) btnClasses.push('btn--disable');

    const images = info.images.map(e => {
      return (
        <div className="session-info__image"><img src={e} alt={info.title}/></div>
      );
    });

    return (
      <div className="buy-checkout-side__container">
        {/* mobile version */}
        <div className="scheme-popup__top">
          <button
            className="scheme-popup__top-btn left"
            type="button"
            onClick={() => onBackClick()}
          >
            <svg
              className="icon--shev"
              width="10"
              height="15"
              viewBox="0 0 5 8"
            >
              <path
                d="M3.6 7.8c.2.1.4.2.6.2.4 0 .8-.4.8-.9 0-.2-.1-.4-.3-.6l-2.6-2.5 2.6-2.5c.2-.2.3-.4.3-.6 0-.5-.4-.9-.8-.9-.2 0-.4.1-.6.2l-3.3 3.1c-.3.3-.4.9 0 1.2l3.3 3.3z"/>
            </svg>
          </button>
          <h4 className="heading heading--2">{info.title ?? 'Информация'}</h4>
        </div>

        {/* desktop version */}
        <button
          onClick={() => onBackClick()}
          className="buy-checkout-side__back"
          type="button"
        >
          <svg width="8" height="5">
            <use href="/local/templates/comfortkino/static/img/icons/icons.svg#i-shev-down"></use>
          </svg>
          Назад
        </button>

        <div className="session-info">
          <h4 className="buy-checkout-side__title session-info__title">{info.title ?? 'Информация'}</h4>
          <Scrollbars
            style={{width: '100%', height: '100%'}}
            autoHeight
            renderTrackVertical={this.renderTrackVertical}
            autoHeightMax={600}
            className="track-vertical"
          >
            <div className="session-info__body">
              <div className="session-info__text">
                <p  style={{whiteSpace: "pre-wrap"}}>{info.body}</p>
              </div>
              {info.video ? (
                <div className="session-info__video">
                  <iframe
                    width="100%"
                    height="190px"
                    title="trailer"
                    className="mfp-iframe"
                    src={this.getIframeUrl(info.video)}
                    frameBorder="0"
                    allowFullScreen
                  />
                </div>
              ) : null}
              {images ? (
                <div className="session-info__images">
                  {images}
                </div>
              ) : null}
            </div>
          </Scrollbars>
        </div>

        <div className="checkout-result__wrapper">
          {this.needAgree() ? (
            <div className="buy-checkout-side__agree">
              <Checkbox
                checked={agree === true}
                name="agree"
                value={agree ? 1 : 0}
                label={'Принимаю'}
                onChange={this.changeAgree}
                small={true}
              />
            </div>
          ) : (<span>&nbsp;</span>)}
          <button
            className={btnClasses.join(' ')}
            type="button"
            onClick={() => {
              this.toCheckout();
            }}
          >
            <span>{info.button ?? 'Далее'}</span>
          </button>
        </div>
      </div>
    );
  }
}

export default Info;
